<template>
  <tr :key="contract.contractId">
    <td @click="showContractDetailPage(contract)">{{ contract.contractId }}</td>
    <td class="name-container" @click="showContractDetailPage(contract)">{{ contract.username }}</td>
    <td class="customer-container" @click="showContractDetailPage(contract)">{{ contract.customerName }}</td>
    <td class="col-1" :class="getBackgroundColorClass(contract.locked)" @click="showContractDetailPage(contract)"/>
    <td class="col-1" :class="getBackgroundColorClass(contract.completed)" @click="showContractDetailPage(contract)"/>
    <td class="col-1" :class="getBackgroundColorClass(contract.confirmedForInvoice)" @click="showContractDetailPage(contract)"/>
    <td @click="showContractDetailPage(contract)">{{ contract.workedHours | convertDotToCommaInNumber }}</td>
    <td>
      <button :disabled="isIndependent()" class="btn-basic btn-outline-pulse mr-2 mb-2" @click="link(contract)">SD Worx</button>
      <button class="btn-basic btn-outline-pulse mb-2" @click="linkToExcel(contract, index)">Facturatie</button>
      <button v-if="isDownloading" class="btn-basic btn-outline-pulse-dark mr-2 mb-2" disabled>Downloading</button>
      <button v-else class="btn-basic btn-outline-pulse-dark mr-2 mb-2" @click="downloadTimeSheetPdf(contract)">Download PDF</button>
      <button class="btn-basic btn-outline-pulse mb-2" @click="linkToPlanning(contract)">Planning</button>
      <button :disabled="!contract.locked" class="btn-basic btn-outline-pulse-dark mr-2 mb-2" @click="unlockThisTimeSheet(contract)">Ontgrendel</button>
      <button :disabled="!contract.completed" class="btn-basic btn-outline-pulse-dark mb-2" @click="openTimeSheet(contract)">Heropen</button>
      <button v-if="!contract.confirmedForInvoice" class="btn-basic btn-fill-pulse mb-2" :disabled="isDisabled" @click="confirmInvoice(contract)">Goedkeuren</button>
      <button v-if="contract.confirmedForInvoice" class="btn-basic btn-fill-pulse-dark mb-2" :disabled="isDisabled" @click="confirmInvoice(contract)">Afkeuren</button>
    </td>
  </tr>
</template>
<script>

import {mapActions, mapGetters, mapMutations} from "vuex";
import timesheet from "../../store/admin/timesheet";
import {toYear} from "@/util/DateUtil";

export default {
  name: "AdminContractRowComponent",
  props: ['contract', 'index'],
  data: () => ({
    isDownloading: false,
    isDisabled: false
  }),

  computed:{
    ...mapGetters({
      users: "administrationUser/users",
      currentlySelectedMonth: "time/currentlySelectedMonth"
    }),
  },
  methods: {
    ...mapActions("administrationTimeSheet", ["downloadAdminTimeSheet", "reopenTimeSheet", "unlockTimeSheet", "toggleConfirmedForInvoice"]),
    ...mapActions("administrationUser", ["fetchAbsenceCountersForUser"]),
    ...mapActions("administrationContract", ["fetchSelectedContractById"]),
    ...mapMutations({
      setSelectedUser: "administrationUser/setSelectedUser",
      setSelectedTimesheetInfo: "administrationTimeSheet/setSelectedCustomerTimesheetInfo",
      setSelectedCustomerTimesheetInfo: "administrationTimeSheet/setSelectedCustomerTimesheetInfo",
      setCurrentlySelectedContractId: "administrationTimeSheet/setCurrentlySelectedContractId",
      setCurrentlySelectedUserId: "administrationTimeSheet/setCurrentlySelectedUserId",
      setCurrentlySelectedContractIndex: "administrationTimeSheet/setCurrentlySelectedContractIndex",
      setSelectedContract: "administrationContract/setSelectedContract"
    }),
    downloadTimeSheetPdf(contract) {
      this.isDownloading = true;
      this.downloadAdminTimeSheet(contract.contractId)
          .then(() => this.isDownloading = false)
          .catch(() => this.isDownloading = false);
    },
    openTimeSheet(contract) {
      this.reopenTimeSheet(contract.contractId);
    },
    unlockThisTimeSheet(contract) {
      this.unlockTimeSheet(contract.contractId);
    },
    confirmInvoice(contract) {
      this.isDisabled = true;
      this.toggleConfirmedForInvoice(contract.contractId)
          .then(() => this.isDisabled = false)
          .catch(() => this.isDisabled = false);
    },
    link: function (contract) {
      var selectedUser;
      for(const user of this.users){
        if(user.firstName + " " + user.lastName === contract.username){
          selectedUser = user;
        }
      }
      this.setSelectedUser(selectedUser);
      this.setSelectedTimesheetInfo(contract);
      this.fetchAbsenceCountersForUser(toYear(this.currentlySelectedMonth));
      this.$router.push({path: "/admin/viewTimeSheet"});
    },
    linkToExcel: function (contract, index) {
      this.fetchSelectedContractById(contract.contractId);
      this.setCurrentlySelectedContractId(contract.contractId);
      this.setCurrentlySelectedUserId(contract.userId);
      this.setCurrentlySelectedContractIndex(index);
      this.$router.push({path: "/admin/viewexcel"});
    },
    linkToPlanning: function (contract) {
      this.setSelectedCustomerTimesheetInfo(contract);
      this.$router.push({path: "/admin/dashboard"});
    },
    getBackgroundColorClass(isCompleted) {
      return isCompleted ? "btn-green" : "btn-red";
    },
    isIndependent() {
      return !this.contract.employee;
    },
    isLocked() {
      return timesheet.isLocked();
    },
    showContractDetailPage(contract) {
      this.fetchSelectedContractById(contract.contractId);
      this.$router.push({path: "/admin/viewcontractDetail"});
    },
  }
};
</script>

<style scoped>
td {
  vertical-align: middle;
}

.bg-green {
  background-color: green;
}

.bg-red {
  background-color: red;
}

.customer-container{
  max-width:142px;
  overflow-wrap:break-word;
}

.name-container{
  max-width:138px;
  overflow-wrap:break-word;
}

</style>